import {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {withRouter} from "react-router-dom"
import {generate} from "../../routes.js"
import {isUserAgent, isUserFreelance, isUserDo} from "../../../shared/services/userService.js"
import connectModal from "../../../shared/components/Modals/connect.js"

import Sidebar from "./Sidebar/Sidebar.jsx"
import MobileMenu from "./MobileMenu/MobileMenu.jsx"
import UserAddModal from "../../components/Modals/UserAddModal/UserAddModal.jsx"

import IcnAgent from "../../../shared/containers/Layout/icons/sidebar/icn-agent.svg"
import IcnAgentActive from "../../../shared/containers/Layout/icons/sidebar/icn-agent-active.svg"
import IcnFile from "../../../shared/containers/Layout/icons/sidebar/icn-file.svg"
import IcnFileActive from "../../../shared/containers/Layout/icons/sidebar/icn-file-active.svg"
import IcnGear from "../../../shared/containers/Layout/icons/sidebar/icn-gear.svg"
import IcnGearActive from "../../../shared/containers/Layout/icons/sidebar/icn-gear-active.svg"
import IcnHome from "../../../shared/containers/Layout/icons/sidebar/icn-home.svg"
import IcnHomeActive from "../../../shared/containers/Layout/icons/sidebar/icn-home-active.svg"
import IcnMegaphone from "../../../shared/containers/Layout/icons/sidebar/icn-megaphone.svg"
import IcnMegaphoneActive from "../../../shared/containers/Layout/icons/sidebar/icn-megaphone-active.svg"
import IcnMegaphonePlus from "../../../shared/containers/Layout/icons/sidebar/icn-megaphone-plus.svg"
import IcnMegaphonePlusActive from "../../../shared/containers/Layout/icons/sidebar/icn-megaphone-plus-active.svg"
import IcnProfile from "../../../shared/containers/Layout/icons/sidebar/icn-profile.svg"
import IcnProfileActive from "../../../shared/containers/Layout/icons/sidebar/icn-profile-active.svg"
import IcnSearch from "../../../shared/containers/Layout/icons/sidebar/icn-search.svg"
import IcnSearchActive from "../../../shared/containers/Layout/icons/sidebar/icn-search-active.svg"
// import IcnSearchIA from "../../../shared/containers/Layout/icons/sidebar/icn-search-ia.svg"
// import IcnSearchIAActive from "../../../shared/containers/Layout/icons/sidebar/icn-search-ia-active.svg"
import IcnTarget from "../../../shared/containers/Layout/icons/sidebar/icn-target.svg"
import IcnTargetActive from "../../../shared/containers/Layout/icons/sidebar/icn-target-active.svg"
import IcnUserAdd from "../../../shared/containers/Layout/icons/sidebar/icn-user-add.svg"
import IcnUserAddActive from "../../../shared/containers/Layout/icons/sidebar/icn-user-add-active.svg"
import IcnUserSearch from "../../../shared/containers/Layout/icons/sidebar/icn-user-search.svg"
import IcnUserSearchActive from "../../../shared/containers/Layout/icons/sidebar/icn-user-search-active.svg"

import {CTA_TYPE} from "./MenuItem/MenuItem.jsx"
import conf from "../../conf.js"

export const FOR_MOBILE = 'mobile'
export const FOR_DESKTOP = 'desktop'

const calendlyJS = 'calendly-js'
const calendlyCSS = 'calendly-css'

class ConnectedMenu extends Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    isFor: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    const {user} = props

    if(isUserAgent(user)) {
      const items = this.getAgentMenuItems()
      this.routes = items.routes
      this.items = items.items
      return
    }

    if(isUserDo(user)) {
      const items = this.getDoMenuItems()
      this.routes = items.routes
      this.items = items.items
      return
    }

    if(isUserFreelance(user)) {
      if(!user.complete) {
        this.routes = {}
        this.items = {}
        return
      }
      const items = this.getFreelanceMenuItems()
      this.routes = items.routes
      this.items = items.items
      return
    }

    this.routes = {}
    this.items = {}
  }

  getDoMenuItems = () => {
    const items = {}

    items.routes = {
      home: generate({name: 'landing-company-connected'}),
      mission: generate({name: 'drop-need'}),
      search: generate({name: 'search'}),
      searchIA: generate({name: 'search-ia'}),
    }

    items.items = {
      home: {
        route: items.routes['home'],
        isCurrentRouteKey: 'home',
        alt: 'entreprise',
        activeIcon: IcnHomeActive,
        icon: IcnHome,
        label: "Entreprise",
        showOnShortMobileMenu: true,
      },
      calendly: {
        type: CTA_TYPE,
        alt: 'calendly',
        activeIcon: IcnAgentActive,
        icon: IcnAgent,
        label: "Rendez vous calendly",
        showOnShortMobileMenu: true,
        onClick: () => {
          this.openCalendlyWidget()
        }
      },
      mission: {
        route: items.routes['mission'],
        isCurrentRouteKey: 'mission',
        alt: 'mission',
        activeIcon: IcnTargetActive,
        icon: IcnTarget,
        label: "Proposer une mission",
        showOnShortMobileMenu: true,
      },
      search: {
        route: items.routes['search'],
        isCurrentRouteKey: 'search',
        alt: 'recherche',
        activeIcon: IcnSearchActive,
        icon: IcnSearch,
        label: "Recherche",
        showOnShortMobileMenu: true,
      },
      // searchIA: {
      //   route: items.routes['searchIA'],
      //   isCurrentRouteKey: 'searchIA',
      //   alt: 'recherche intelligente',
      //   activeIcon: IcnSearchIAActive,
      //   icon: IcnSearchIA,
      //   label: "Recherche intelligente",
      //   showOnShortMobileMenu: true,
      // },
    }
    return items
  }

  componentDidMount() {
    this.setupCalendly()
  }


  setupCalendly = () => {
    const head = document.getElementsByTagName('head')[0]

    if (document.getElementById(calendlyJS) === null) {
      const script = document.createElement("script")
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      script.id = calendlyJS
      script.async = true

      head.appendChild(script)
    }

    if (document.getElementById(calendlyCSS) === null) {
      const link = document.createElement('link')
      link.href = 'https://assets.calendly.com/assets/external/widget.css'
      link.id = calendlyCSS
      link.rel = 'stylesheet'

      head.appendChild(link)
    }
  }

  openCalendlyWidget = () => {
    this.setupCalendly()
    window.Calendly.initPopupWidget({
      url: conf.calendly.do,
      prefill: {
        name: this.props?.user.fullname ?? '',
        email: this.props?.user.email ?? '',
        customAnswers: {
          a1: this.props?.user.tel ?? ''
        }
      }
    })
  }

  getAgentMenuItems = () => {
    const items = {}

    items.routes = {
      home: generate({name: 'freelance-dashboard'}),
      search: generate({
        name: 'search',
        search: {
          active: 1,
          cdi: 0,
          complete: 1,
        }}
      ),
      searchIA: generate({name: 'search-ia'}),
      profile: generate({name: 'profiles'}), // nouvelle page vue profil trello ou en ligne (à créer)
      offers: generate({name: 'offers'}),
      offersAdd:generate({name: 'offers.create'}),
      userSearch: generate({name: 'purchasers'}),
    }

    items.items = {
      home: {
        route: items.routes['home'],
        isCurrentRouteKey: 'home',
        alt: 'home',
        activeIcon: IcnHomeActive,
        icon: IcnHome,
        label: "Dashboard",
        showOnShortMobileMenu: true,
      },
      search: {
        route: items.routes['search'],
        isCurrentRouteKey: 'search',
        alt: 'recherche',
        activeIcon: IcnSearchActive,
        icon: IcnSearch,
        label: "Recherche",
        showOnShortMobileMenu: true,
      },
      // searchIA: {
      //   route: items.routes['searchIA'],
      //   isCurrentRouteKey: 'searchIA',
      //   alt: 'recherche intelligente',
      //   activeIcon: IcnSearchIAActive,
      //   icon: IcnSearchIA,
      //   label: "Recherche intelligente",
      //   showOnShortMobileMenu: true,
      // },
      profile: {
        route: items.routes['profile'],
        isCurrentRouteKey: 'profile',
        alt: 'profile',
        activeIcon: IcnProfileActive,
        icon: IcnProfile,
        label: "Profils",
        showOnShortMobileMenu: true,
      },
      userAdd: {
        type: CTA_TYPE,
        alt: 'create profile',
        activeIcon: IcnUserAddActive,
        icon: IcnUserAdd,
        label: "Créer un profil",
        showOnShortMobileMenu: true,
        onClick: () => {
          this.addUser()
        }
      },
      offers: {
        route: items.routes['offers'],
        isCurrentRouteKey: 'offers',
        alt: 'megaphone',
        activeIcon: IcnMegaphoneActive,
        icon: IcnMegaphone,
        label: "Annonces",
      },
      offersAdd: {
        route: items.routes['offersAdd'],
        isCurrentRouteKey: 'offersAdd',
        alt: 'megaphone',
        activeIcon: IcnMegaphonePlusActive,
        icon: IcnMegaphonePlus,
        label: "Créer une annonce",
      },
      userSearch: {
        route: items.routes['userSearch'],
        isCurrentRouteKey: 'userSearch',
        alt: 'megaphone',
        activeIcon: IcnUserSearchActive,
        icon: IcnUserSearch,
        label: "Do",
      },
    }
    return items
  }

  addUser = () => {
    this.props.openUserAddModal({})
  }

  getFreelanceMenuItems = () => {
    const items = {}
    items.routes = {
      agent: generate({name: 'freelance-agent'}),
      home: generate({name: 'freelance-dashboard'}),
      offers: generate({name: 'offers'}),
      target: generate({
        name: `my-positions-and-missions`,
      }),
      profile: generate({name: 'my-freelance-profile'}),
      pres: generate({name: 'edit-freelance.pres'}),
      cv: generate({name: 'edit-freelance.cv'}),
    }

    items.items = {
      home: {
        route: items.routes['home'],
        isCurrentRouteKey: 'home',
        alt: 'home',
        activeIcon: IcnHomeActive,
        icon: IcnHome,
        label: "Dashboard",
        showOnShortMobileMenu: true,
      },
      agent: {
        route: items.routes['agent'],
        isCurrentRouteKey: 'agent',
        alt: 'agent',
        activeIcon: IcnAgentActive,
        icon: IcnAgent,
        label: "Mon agent",
      },
      offers: {
        route: items.routes['offers'],
        isCurrentRouteKey: 'offers',
        alt: 'megaphone',
        activeIcon: IcnMegaphoneActive,
        icon: IcnMegaphone,
        label: "Missions",
        showOnShortMobileMenu: true,
      },
      target: {
        route: items.routes['target'],
        isCurrentRouteKey: 'target',
        alt: 'target',
        activeIcon: IcnTargetActive,
        icon: IcnTarget,
        label: "Positions",
        tooltip: "Positionnements et missions",
        showOnShortMobileMenu: true,
      },
      profile: {
        route: items.routes['profile'],
        isCurrentRouteKey: 'profile',
        alt: 'profile',
        activeIcon: IcnProfileActive,
        icon: IcnProfile,
        label: "Aperçu du profil",
      },
      pres: {
        route: items.routes['pres'],
        isCurrentRouteKey: 'pres',
        alt: 'gear',
        activeIcon: IcnGearActive,
        icon: IcnGear,
        label: "Profil",
        tooltip: "Modifier mon profil",
        showOnShortMobileMenu: true,
      },
      cv: {
        route: items.routes['cv'],
        isCurrentRouteKey: 'cv',
        alt: 'file',
        activeIcon: IcnFileActive,
        icon: IcnFile,
        label: "Mon CV",
      },
    }
    return items
  }


  isCurrentRoute = (key) => {
    const route = this.routes[key]
    const routePathname = route ? route.split('?')[0] : route
    return routePathname === this.props.location.pathname
  }

  render() {
    const {items} = this
    const {isFor} = this.props

    if(!items || !Object.keys(items).length) {
      return null
    }

    if(isFor === FOR_MOBILE) {
      return <MobileMenu items={items} isCurrentRoute={this.isCurrentRoute} />
    }

    return(
      <Fragment>
        <Sidebar items={items} isCurrentRoute={this.isCurrentRoute} />
      </Fragment>
    )
  }
}

export default withRouter(connectModal({UserAddModal}, ConnectedMenu))
